export enum ActivePageEnum {
  Order = 1,
  Customer = 2,
  Salon = 3,
  Invoices = 4,
  New = 5,
  OrderItem = 6,
  Invoice = 7,
  OnlineFactor = 8,
  ReserveOnline = 9,
}

export enum SaleElementSize {
  Item = 1,
  Invoice = 2,
}
